import { KuikaBadgeColor } from "../../ui-kit/kuika-badge/kuika-badge";

/**
 * The colour of a ticket's `#id` chip.
 *
 * It is deliberately NOT the ticket's status: status already has its own chip in the same row, and
 * tinting the id from it made a solved inbox one repeated colour with nothing to tell the rows
 * apart. The id gets its own hue instead, so a long list reads as distinct entries and a ticket
 * number you have seen before is recognisable on sight.
 *
 * "Varied" but not random: the hue is DERIVED from the id, so a ticket keeps the same colour on
 * every render, in every surface (list row, board card, the open ticket's header) and after a
 * reload. An actually-random pick would reshuffle the list on every keystroke of the search box.
 */

// Red is absent on purpose — it means "error" everywhere else in this product, and an id is never
// an error. Grey is absent because a colourless chip is the thing this replaced.
const TICKET_ID_COLORS: readonly KuikaBadgeColor[] = ["blue", "green", "purple", "orange", "pink", "yellow"];

export function getTicketIdColor(ticketId: number | string): KuikaBadgeColor {
  const key: string = String(ticketId);
  let hash: number = 0;
  for (let index = 0; index < key.length; index += 1) {
    // Plain FNV-ish accumulation: the ids are short numeric strings, so anything fancier buys
    // nothing. `| 0` keeps it in int32 instead of drifting into float territory on long keys.
    hash = (hash * 31 + key.charCodeAt(index)) | 0;
  }
  return TICKET_ID_COLORS[Math.abs(hash) % TICKET_ID_COLORS.length];
}
